import { createContext } from 'react';

export type UserBrandLookup = {
  id: string;
  name: string;
  displayName: string | null;
};

export type UserBrandDrugClassProductBrandMapping = {
  drugClass: UserBrandLookup;
  productBrands: UserBrandLookup[];
};

export type UserBrand = {
  identifier: string;
  name: string;
  productBrand?: UserBrandLookup | null;
  indication?: UserBrandLookup | null;
  therapeuticArea?: UserBrandLookup | null;
  productBrands?: UserBrandLookup[];
  drugClasses?: UserBrandLookup[];
  genericDrugs?: UserBrandLookup[];
  drugClassProductBrandMappings?: UserBrandDrugClassProductBrandMapping[];
};

export const ActiveBrandContext = createContext<string | null>(null);
export const ActiveBrandDetailsContext = createContext<UserBrand | null>(null);
export const UserBrandsContext = createContext<UserBrand[]>([]);
export const SetActiveBrandContext = createContext<React.Dispatch<React.SetStateAction<string>>>(() => {});
